module.exports = __webpack_public_path__ + "static/media/sariga_design.301ff53d.jpeg";